export function cloneObject<T>(obj: T): T {
  if (!obj) {
    return null;
  }
  return JSON.parse(JSON.stringify(obj));
}
